import {CircularProgress, TextField} from '@mui/material';
import {Autocomplete} from '@mui/lab';
import {useFormikContext} from 'formik';
import React from 'react';
import {upperFirstLetter} from '../constants/format';

const AutoComplete = ({prop = '', fetchData, options, loading}) => {
    const formik = useFormikContext()
    const handleChange = prop => (event, value) => {
        formik.setFieldValue(prop, value.iso2 || value.name || value)
        switch (prop) {
            case 'country':
                fetchData('states', value.iso2)
                formik.setFieldValue('state', null)
                formik.setFieldValue('city', null)
                break;
            case 'state':
                fetchData('cities', formik.values.country, value.iso2)
                formik.setFieldValue('city', null)
                break;
            default:
                break;
        }
    }
    return (
        <>
            <Autocomplete
                id={prop}
                value={formik.values[prop]}
                onChange={handleChange(prop)}
                options={!loading ? options : []}
                getOptionLabel={option => option.name || (prop !== "city" ? (options.find(x => x?.iso2 === option)?.name) : option)}
                getOptionSelected={(option, value) => (option.iso2 || option.name) === (value.iso2 || value.name || value)}
                onBlur={formik.handleBlur(prop)}
                loading={loading}
                loadingText='loading'
                disableClearable
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={`${upperFirstLetter(prop)} Name`}
                        variant="outlined"
                        size="small"
                        required
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
        </>
    );
}

export default AutoComplete;
